import React from 'react'
import { Collapsible } from 'components/molecules/Collapsible'
import { FileProps } from 'types/file'
import FileItem from 'components/molecules/DeleteFile/components/FileItem'
import { useDispatch, useSelector } from 'react-redux'
import { setFileDeletionRequest } from 'store/file/file.actions'
import { selectSetFileDeletionStatuses } from 'store/file/file.selectors'
import { LoadingStatus } from 'types/loading'

type DeleteFileProps = {
  uploadedFiles?: FileProps[]
}

export const DeleteFile: React.FC<DeleteFileProps> = ({ uploadedFiles }) => {
  const dispatch = useDispatch()
  const deletedFiles = uploadedFiles?.filter((item) => item.data?.isDeleted)
  const statuses = useSelector(selectSetFileDeletionStatuses)

  const onRestore = (file: FileProps) => {
    dispatch(
      setFileDeletionRequest({
        uuid: file.uuid,
        isDeleted: false,
      }),
    )
  }

  if (deletedFiles?.length)
    return (
      <Collapsible title="Удалённые документы">
        <div>
          {deletedFiles.map((file: FileProps) => (
            <FileItem
              key={file.uuid}
              file={{
                uuid: file.uuid,
                name: file.name,
                data: file.data,
                createdAt: file.createdAt,
              }}
              onRestore={onRestore}
              deleteLoading={statuses[file.uuid] === LoadingStatus.PENDING}
            />
          ))}
        </div>
      </Collapsible>
    )
  return null
}
